import { useState, useEffect } from "react";
import TableAHSF from "../../../../Components/TableAHSF";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../../../Components/PopupAHSF";
import AddEditExperienceSummary from "./AddEditExperienceSummary";

const OrgExperienceSummary = (props) => {
  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [ExperinceSummaryId, setExperinceSummaryId] = useState(null);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          ?.TeamMembersPreviousExperiencePartnerships,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "projectName",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "briefDescriptionOfProject",
      ShowStatus: true,
      NmaeColumn: "  نبذة قصيرة عن المشروع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "yearOfImplementation",
      ShowStatus: true,
      NmaeColumn: "سنة تنفيذ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "durationOfImplementationInMonths",
      ShowStatus: true,
      NmaeColumn: "مدة التنفيذ بالاشهر",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "countryWhereProjectWasImplemented",
      ShowStatus: true,
      NmaeColumn: "الدولة التي تم تنفيذ المشروع فيها",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "governorateRegion",
      ShowStatus: true,
      NmaeColumn: "المحافظة - المنطقة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "nameOfProjectDonor",
      ShowStatus: true,
      NmaeColumn: "اسم الجهة المانحة للمشروع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "amountOfSupportReceived",
      ShowStatus: true,
      NmaeColumn: "قيمة الدعم التي تم الحصول عليها",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true
    },
    {
      KeyName: "contactPersonFromDonorOrganizationName",
      ShowStatus: true,
      NmaeColumn: "الشخص المعني من الجهة الداعمة– الاسم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "contactInformationEmailPhone",
      ShowStatus: true,
      NmaeColumn: "معلومات الاتصال (بريد الكتروني، هاتف):",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setExperinceSummaryId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/TE_PreviousExperienceSummary/DeleteTE_PreviousExperienceSummaryData",
              {
                tE_PreviousExperienceSummaryId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditExperienceSummary />}</div>,
    title: "ملخص عن الخبرات السابقة للجهة/المؤسسة",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditExperienceSummary
          tE_PreviousExperienceSummaryId={ExperinceSummaryId}
          canEdit="edit"
        />
      </div>
    ),
    title: "ملخص عن الخبرات السابقة للجهة/المؤسسة",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  //console.log(state.TeamMembersPreviousExperiencePartnerships, "ghhhghhg");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"tE_PreviousExperienceSummaryId"}
        valueButtonAction={"tE_PreviousExperienceSummaryId"}
        URL={`api/TE_PreviousExperienceSummary/GetTE_PreviousExperienceSummaryList`}
        UrlBody={{
          tE_MAinTeamMembersPreviousExperiencePartnershipsId:
            props.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={" ملخص عن الخبرات السابقة للجهة/المؤسسة"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};
export default OrgExperienceSummary;
